import { useCallback, useEffect, useState } from "react";
import { useFetchDocument } from "./useFetchDocument";

export const useOpenDocument = () => {
  const [shouldFetch, setShouldFetch] = useState(false);
  const [currentDocumentId, setCurrentDocumentId] = useState<string | null>(null);

  const { attachment, isLoading } = useFetchDocument(currentDocumentId, { isEnabled: shouldFetch });
  const attachmentUrl = attachment?.document?.fileUrl;

  useEffect(() => {
    if (!attachmentUrl || isLoading) return;

    window.open(attachmentUrl, "_blank");
  }, [attachmentUrl, isLoading]);

  const openDocument = useCallback(
    (documentId: string) => {
      if (attachmentUrl && currentDocumentId === documentId) {
        window.open(attachmentUrl, "_blank");
        return;
      }

      setCurrentDocumentId(documentId);
      setShouldFetch(true);
    },
    [attachmentUrl, currentDocumentId]
  );

  return { openDocument, isDocumentLoading: isLoading };
};
